import { render } from "./SpecimenLabelPrinter.vue?vue&type=template&id=10f18574&scoped=true&ts=true"
import script from "./SpecimenLabelPrinter.vue?vue&type=script&lang=ts"
export * from "./SpecimenLabelPrinter.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\nyffeler\\IdeaProjects\\data_tools\\Branches\\data_tools\\131\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f18574"]])

export default __exports__